import React from 'react';
import './search.css';
import config from '../../config';
import Loading from '../../components/loading';
import {withRouter} from 'react-router';
import Autocomplete from 'react-autocomplete';
import OfferNew from './offer-new';
import PropTypes from 'prop-types';
import {
  Form,
  FormGroup
} from 'react-bootstrap/lib';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      loading: false,
      items: [],
      offerNew: false
    };
  }

  timer = null;

  fetch = () => {
    const value = this.state.value.trim();
    fetch(`${config.apiUrl}/coins?label=${value}`)
      .then(resp => {
        this.setState({loading: false});
        return resp.json();
      })
      .then(items => {
        this.setState({items});
        if (value.length >= 3 && items.length === 0) {
          this.setState({offerNew: true});
        } else {
          this.setState({offerNew: false});
        }
      });
  }
  handleChange = e => {
    this.setState({loading: true, offerNew: false});
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    const {target: {value}} = e;
    this.setState({value});
    if (value.length < 3) {
      this.setState({loading: false});
    } else {
      this.timer = setTimeout(this.fetch, 1000);
    }
  }

  handleSelect = value => {
    this.setState({value});
    const match = this.state.items.filter(item => item.name === value)[0];
    this.props.history.push('/details/' + match._id);
  }
  render() {
    const {state: {value}} = this;
    return (
      <Form className="search-form" >
        <FormGroup>
          <span className="input-group">
            <Autocomplete
              open={true}
              inputProps={{
                placeholder: 'Enter Coin Name',
                className: 'form-control'
              }}

              getItemValue={item => item.name}
              items={this.state.items}
              shouldItemRender={(e, str) => {
                return !this.state.loading && str;
              }}
              renderMenu={children => <div className="menu"> {children} </div>}
              renderItem={(item, isHighlighted) => {
                return (
                  <div key={item._id} style={{background: isHighlighted ? 'lightgray' : 'white'}}>
                    {item.name}
                  </div>
                );
              }}
              wrapperProps={{
                style: {
                  width: '100%'
                }
              }}
              value={value}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
            />
            <span className="input-group-addon">
              <span className="glyphicon glyphicon-search"></span>
            </span>
          </span>
          {this.state.loading && <Loading /> }
          {this.state.offerNew && <OfferNew label={value} />}
        </FormGroup>

      </Form>
    );
  }
}
Search.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};
export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/home/search/index.js